import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Translator } from "./_";
import _ from 'lodash';
import React from 'react';
export var SuperProColumn = /*#__PURE__*/_createClass(function SuperProColumn() {
  _classCallCheck(this, SuperProColumn);
});
_defineProperty(SuperProColumn, "generateColumns", function (parameters) {
  // 构建列
  // > -
  var columns0 = [{
    dataIndex: 'id',
    valueType: 'digit',
    hideInTable: true,
    title: Translator.formatMessage({
      id: 'Identifier'
    })
  }, {
    valueType: 'text',
    dataIndex: 'uuid',
    copyable: true,
    ellipsis: true,
    hideInTable: true,
    title: Translator.formatMessage({
      id: 'Universally'
    })
  }].concat(_toConsumableArray(parameters.otherColumns || []), [{
    valueType: 'dateTime',
    dataIndex: 'createdAt',
    title: Translator.formatMessage({
      id: 'Created At'
    })
  }, {
    hideInTable: true,
    valueType: 'dateTime',
    dataIndex: 'updatedAt',
    title: Translator.formatMessage({
      id: 'Updated At'
    })
  }, {
    width: 64,
    align: 'center',
    fixed: 'right',
    valueType: 'option',
    title: Translator.formatMessage({
      id: 'Action'
    }),
    render: function render(_, entity, __, action) {
      return parameters.action && /*#__PURE__*/React.cloneElement(parameters.action, {
        action: action,
        entity: entity
      });
    }
  }]);
  // > -
  var columns = [];
  // 填充列
  columns0.forEach(function (column) {
    var _column$hideInSearch;
    // 将部分字段转换为范围搜索
    switch (column.valueType) {
      case 'dateTime':
        {
          // 插入字段
          columns.push(_objectSpread(_objectSpread({}, column), {}, {
            hideInTable: true,
            hideInDescriptions: true,
            valueType: 'dateTimeRange'
          }));
          // 跳出
          break;
        }
      case 'money':
      case 'digit':
        {
          // 插入字段
          columns.push(_objectSpread(_objectSpread({}, column), {}, {
            hideInTable: true,
            valueType: 'digitRange',
            hideInDescriptions: true
          }));
          // 跳出
          break;
        }
      case 'preciseDigit':
      case 'preciseMoney':
        {
          // 插入字段
          columns.push(_objectSpread(_objectSpread({}, column), {}, {
            hideInTable: true,
            hideInDescriptions: true,
            valueType: 'preciseDigitRange'
          }));
          // 跳出
          break;
        }
      default:
        {
          break;
        }
    }
    // 隐藏转换前的字段
    columns.push(_objectSpread(_objectSpread({
      align: 'center'
    }, column), {}, {
      width: function () {
        if (column.width) {
          return column.width;
        } else if (_.isEqual(column.dataIndex, 'id')) {
          return Math.pow(2, 6.4);
        }
      }(),
      hideInSearch: (_column$hideInSearch = column.hideInSearch) !== null && _column$hideInSearch !== void 0 ? _column$hideInSearch : ['dateTime', 'money', 'digit', 'preciseDigit', 'preciseMoney'].includes(String(column.valueType))
    }));
  });
  // 返回列
  return columns;
});
_defineProperty(SuperProColumn, "generateHighlightColumn", function (parameters) {
  return _objectSpread(_objectSpread({
    // title: '名称',
    fixed: 'left',
    ellipsis: true,
    valueType: 'text'
  }, parameters), {}, {
    render: function render(dom, entity, index, action, schema) {
      var _parameters$token, _parameters$render;
      // -
      var element = /*#__PURE__*/React.cloneElement(dom, {
        style: {
          color: (_parameters$token = parameters.token) === null || _parameters$token === void 0 ? void 0 : _parameters$token.token.colorPrimary
        }
      });
      // -
      return ((_parameters$render = parameters.render) === null || _parameters$render === void 0 ? void 0 : _parameters$render.call(parameters, element, entity, index, action, schema)) || element;
    }
  });
});
export var generateColumns = SuperProColumn.generateColumns;